export default __webpack_public_path__ + "static/media/container.6dfb8a17.png";